import { HoldingUserPermissions, UserPermissions } from "../types";
import { AppPermissionsTemplate, FeaturePermissionsTemplate } from "./templates";
import { sprayPlansHaloAudit, sprayPlansEnhancedAudit } from "./sprayPlans"
import { ReadWritePermissions } from "../../../../../shared/permissions/types";

type HubPermissions = HoldingUserPermissions["hub"]

type PermissionsTemplate = AppPermissionsTemplate<HubPermissions>["permissions"]

export interface HubPermissionsTemplate extends AppPermissionsTemplate<HubPermissions> {

    permissions: PermissionsTemplate & {
        sprayPlansHaloAudit: FeaturePermissionsTemplate<HubPermissions>
        // 250509 - Disabled for now as per devops #1827
        // sprayPlansEnhancedAudit: FeaturePermissionsTemplate<HubPermissions>
    }
}

export const hubPermissionsTemplate: HubPermissionsTemplate = {

    name: "Omnia",

    permissions: {

        holdings: readWrite("holdings", "Holdings"),

        fields: readWrite("fields", "Fields"),

        mapLayers: readWrite("mapLayers", "Map layers"),

        stocks: {
            name: "Stocks",
            selector: a => a.stocks,
            isAvailable: u => u?.stocks?.read,
            type: "readWriteFinancial"
        },

        soil: readWrite("soil", "Soil"),

        climate: readWrite("climate", "Climate"),

        seedPlans: readWrite("seedPlans", "Seed plans"),

        nutritionPlans: readWrite("nutritionPlans", "Nutrition plans"),

        sprayPlans: readWrite("sprayPlans", "Spray plans"),

        sprayPlansHaloAudit,
        // 250509 - Disabled for now as per devops #1827
        // sprayPlansEnhancedAudit,

        manure: readWrite("manure", "Manure"),

        fieldDiary: readWrite("fieldDiary", "Field diary"),

        taskManagement: readWrite("taskManagement", "Task management"),

        exports: {
            name: "Exports",
            selector: a => a.exports,
            isAvailable: u => u?.exports?.enabled ?? false,
            type: "access"
        },

        reports: {
            name: "Reports",
            selector: a => a.reports,
            isAvailable: u => u?.reports?.enabled ?? false,
            type: "access"
        },

        yield: {
            name: "Business Yield",
            selector: a => a.yield,
            isAvailable: u => u?.yield?.read,
            type: "readWrite"
        },

        shed: {
            name: "Business Shed",
            selector: a => a.shed,
            isAvailable: u => u?.shed?.read,
            type: "readWriteFinancial"
        },

        production: {
            name: "Business Production",
            selector: a => a.production,
            isAvailable: u => u?.production?.read,
            type: "readWrite"
        },

        planning: {
            name: "Business Planning",
            selector: a => a.planning,
            isAvailable: u => u?.planning?.read,
            type: "readWrite"
        },

    }

} as const



// Hub permissions shared at holding and user level
type SharedHubPermissions = HoldingUserPermissions["hub"] & UserPermissions

// Subset with the read-write type
type ReadWriteSharedPermissions = {
    [property in keyof SharedHubPermissions]: SharedHubPermissions[property] extends ReadWritePermissions ? SharedHubPermissions[property] : never
}

function readWrite(key: keyof ReadWriteSharedPermissions, name: string) {
    return {
        key,
        type: "readWrite",
        name,
        selector: (a: ReadWriteSharedPermissions) => a[key],
        isAvailable: (a: ReadWriteSharedPermissions) => a?.[key]?.read ?? false
    } as const
}
